module.exports = __webpack_public_path__ + "static/media/video.c91385f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/detail/jolin/1/video.mp4
// module id = Y9Pb
// module chunks = 1